import React from "react";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { useFavorites, FavKind } from "@/hooks/useFavorites";
import { usePrefs } from "@/contexts/PrefsContext";

export const HeartButton = ({ venueId, eventId, spotId, className = "" }: { venueId?: string; eventId?: string; spotId?: string; className?: string }) => {
  const kind: FavKind = eventId ? "events" : spotId ? "spots" : "venues";
  const id = (eventId || spotId || venueId) as string;
  const { isFav, toggle } = useFavorites(kind);
  const { t } = usePrefs();
  const on = isFav(id);
  return (
    <motion.button
      whileTap={{ scale: 0.8 }}
      data-testid={eventId ? `event-favorite-toggle-${id}` : spotId ? `spot-favorite-toggle-${id}` : `favorite-toggle-${id}`}
      aria-pressed={on}
      aria-label={t(on ? "fav.remove" : "fav.add")}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle(id);
      }}
      className={`h-10 w-10 grid place-items-center rounded-full backdrop-blur-md shadow-lg transition-[background-color] ${on ? "bg-white" : "bg-black/35 hover:bg-black/50"} ${className}`}
    >
      <Heart className={`h-5 w-5 transition-colors ${on ? "fill-primary text-primary" : "text-white"}`} />
    </motion.button>
  );
};
